import { loadItemsOnDateRangeChange } from 'owa-calendar-surface-view-store';
import { surfaceStore } from 'owa-calendar-surface-surface-store';
import updateSurfaceOptions from 'owa-calendar-appearance-option/lib/data/actions/updateSurfaceOptions';
import { orchestrator } from 'satcheljs';
import { initializeSurfaceOptions } from '../utils/initializeSurfaceOptions';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module

/**
 * The actions for updating calendar appearance settings are defined in owa-calendar-appearance-option package under owa-mail.
 * To reflect the settings in calendar surface without refreshing the page we dispatch an action updateSurfaceOptions from
 * saveAppearanceOption in owa-mail (packages/options/config/calendar/owa-calendar-appearance-option/lib/orchestration/saveAppearanceOption)
 * and in calendar this orchestrator listening to it which initializes the surface options with updated userConfiguration
 */
export default orchestrator(updateSurfaceOptions, () => {
    initializeSurfaceOptions();
    loadItemsOnDateRangeChange(surfaceStore.dateRange, surfaceStore.dateRangeType);
});
